export default "__VITE_ASSET__DOiWIVa___"